import { CardSection } from '../Card/CardSection.js';
import { themed } from '@indeed/ifl-css';

const CheckboxCardBody = /*#__PURE__*/themed(CardSection, process.env.NODE_ENV === "production" ? {
  target: "esmxdwp0"
} : {
  target: "esmxdwp0",
  label: "CheckboxCardBody"
})(() => ({}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrYm94Q2FyZEJvZHkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdnQyIsImZpbGUiOiJDaGVja2JveENhcmRCb2R5LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENhcmRTZWN0aW9uLCBDYXJkU2VjdGlvbkNvbXBvbmVudCB9IGZyb20gXCIuLi9DYXJkL0NhcmRTZWN0aW9uXCI7XG5pbXBvcnQgeyB0aGVtZWQgfSBmcm9tIFwiQGluZGVlZC9pZmwtY3NzXCI7XG5cbmV4cG9ydCBjb25zdCBDaGVja2JveENhcmRCb2R5ID0gdGhlbWVkKFxuICBDYXJkU2VjdGlvbixcbiAge31cbikoKCkgPT4gKHt9KSkgYXMgQ2FyZFNlY3Rpb25Db21wb25lbnQ7XG5cbkNoZWNrYm94Q2FyZEJvZHkuZGlzcGxheU5hbWUgPSBcIkNoZWNrYm94Q2FyZEJvZHlcIjtcbiJdfQ== */");
CheckboxCardBody.displayName = "CheckboxCardBody";

export { CheckboxCardBody };
